import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class MyCustomPaginatorIntl extends MatPaginatorIntl {
    firstPageLabel = 'Primera página';
    itemsPerPageLabel = 'Registros por página:';
    lastPageLabel = 'Última página';

    nextPageLabel = 'Siguiente página';
    previousPageLabel = 'Página anterior';

    constructor() {
        super();
        this.changes.next();
    }

    getRangeLabel = (page: number, pageSize: number, length: number): string => {
        if (length === 0) {
            return 'Página 1 de 1';
        }

        const amountPages = Math.ceil(length / pageSize);
        return `Página ${page + 1} de ${amountPages}`;
    };
}
